import React from 'react';
import { motion } from 'framer-motion';
import { Star, TrendingUp, Clock } from 'lucide-react';

interface CurrentSkillsProps {
  skills: {
    name: string;
    level: number;
    lastPracticed: string;
    trend: 'up' | 'down' | 'stable';
  }[];
}

const CurrentSkills: React.FC<CurrentSkillsProps> = ({ skills }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="bg-white p-6 rounded-xl shadow-md"
    >
      <h3 className="text-xl font-semibold text-gray-900 mb-6">Your Current Skills</h3>
      <div className="space-y-4">
        {skills.map((skill, index) => (
          <div key={index} className="p-4 bg-gray-50 rounded-lg">
            <div className="flex items-center justify-between mb-3">
              <div>
                <h4 className="font-medium text-gray-900">{skill.name}</h4>
                <div className="flex items-center mt-1 text-sm text-gray-500">
                  <Clock className="h-4 w-4 mr-1" />
                  Last practiced: {skill.lastPracticed}
                </div>
              </div>
              <div className="flex items-center">
                {skill.trend === 'up' && (
                  <div className="flex items-center text-green-600 bg-green-50 px-3 py-1 rounded-full text-sm">
                    <TrendingUp className="h-4 w-4 mr-1" />
                    Improving
                  </div>
                )}
              </div>
            </div>
            <div className="relative pt-1">
              <div className="flex mb-2 items-center justify-between">
                <div>
                  <span className="text-xs font-semibold inline-block py-1 px-2 uppercase rounded-full text-primary-600 bg-primary-200">
                    Progress
                  </span>
                </div>
                <div className="text-right">
                  <span className="text-xs font-semibold inline-block text-primary-600">
                    {skill.level}%
                  </span>
                </div>
              </div>
              <div className="overflow-hidden h-2 mb-4 text-xs flex rounded bg-primary-200">
                <div 
                  style={{ width: `${skill.level}%` }}
                  className="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-primary-500 transition-all duration-500"
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </motion.div>
  );
};

export default CurrentSkills;